import { createFileRoute } from "@tanstack/react-router";
import { TenantDocSettings } from "@client/components/admin/tenant-info/tenant-doc-settings";

export const Route = createFileRoute("/_app/tenant-settings/doc-settings")({
  component: DocSettingsPage,
});

function DocSettingsPage() {
  return (
    <div className="grid gap-6 p-6">
      <TenantDocSettings />
    </div>
  );
}
